import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useEventCallback } from 'usehooks-ts';

import { LikesCardDetail } from '@/features/likes/components/unrevealedCard';
import { getMyProfileOptions } from '@/features/profile/hooks/useGetMyProfile/getMyProfile.options';
import { getBalanceOptions } from '@/features/subscription/hooks/useGetBalance/getBalance.options';
import { isPremium } from '@/features/subscription/utils/isPremium';
import { MainLayout } from '@/shared/components/mainLayout';
import { PageHeader } from '@/shared/components/pageHeader';

export const Route = createFileRoute('/_protected/_app/_mainLayout/likes/$id')({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    // Prefetch balance in background (non-blocking)
    void context.queryClient.prefetchQuery(getBalanceOptions());

    // Ensure user profile is loaded
    const { profile } = await context.queryClient.ensureQueryData(
      getMyProfileOptions(),
    );

    if (!isPremium(profile)) {
      // Redirect to my-duos list if not an premium user
      throw redirect({ to: '/likes', replace: true });
    }
  },
});

function RouteComponent() {
  const navigate = useNavigate();

  const handleGoBack = useEventCallback(() => {
    void navigate({ to: '/likes' });
  });

  return (
    <MainLayout.Root className="h-full">
      <PageHeader.Root>
        <PageHeader.BackButton onClick={handleGoBack} />
      </PageHeader.Root>
      <MainLayout.Content className="flex min-h-0 flex-col px-4">
        <LikesCardDetail />
      </MainLayout.Content>
    </MainLayout.Root>
  );
}
